module.exports = __webpack_public_path__ + "static/sol-healthcare-section-4-img-5016f027f6a1cc1cc04aff531f3cc01f.png";